<template>
  <div class="flex w-full items-center">
    <button
      v-for="(option, index) in options"
      :key="option.id"
      class="padding-top flex-1 border px-2"
      :class="{
        'bg-dark-gray text-white': selected === option.id,
        'text-gray-over-dark': selected !== option.id,
        'rounded-l': index === 0,
        'rounded-r': index === options.length - 1,
      }"
      @click="onSelectOption(option)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'FlatRadioButtons',
  props: {
    options: Array,
    selected: String,
  },
  emits: ['selected'],
  methods: {
    onSelectOption: function (option) {
      this.$emit('selected', option);
    },
  },
};
</script>

<style>
.padding-top {
  padding-top: 13px;
  padding-bottom: 13px;
}
</style>
